import { getBundleAwareItemCount } from '../../common/bundleHelpers';

export const getItemCount = (cart) => {
  let itemCount = 0;

  if (cart?.items) {
    itemCount = getBundleAwareItemCount(cart.items);
  }
  return itemCount;
};
